import Vue from 'vue'
import {
  Vuetify,
  VApp,
  VFooter,
  VBtn,
  VIcon,
  VGrid,
  VAvatar,
  VAlert
} from 'vuetify'
import 'vuetify/src/stylus/app.styl'
import de from 'vuetify/es5/locale/de'

Vue.use(Vuetify, {
  components: {
    VApp,
    VFooter,
    VBtn,
    VIcon,
    VGrid,
    VAvatar,
    VAlert
  },
  theme: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  customProperties: true,
  iconfont: 'mdi',
  lang: {
    locales: { de },
    current: 'de'
  }
})
